import React, { useEffect, useState, useRef } from "react";
import { experiences } from "../config/config";

const Experience = () => {
  const [isVisible, setIsVisible] = useState(
    Array(experiences.length).fill(false)
  );
  const timelineRef = useRef(null);
  const lastCardRef = useRef(null);

  useEffect(() => {
    const handleScroll = () => {
      const elements = document.querySelectorAll(".experience-card");
      elements.forEach((element, index) => {
        const rect = element.getBoundingClientRect();
        if (rect.top < window.innerHeight * 0.8) {
          setIsVisible((prevState) => {
            const newState = [...prevState];
            newState[index] = true;
            return newState;
          });
        }
      });
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
    if (timelineRef.current && lastCardRef.current) {
      const timelineTop = timelineRef.current.getBoundingClientRect().top;
      const lastCardTop = lastCardRef.current.getBoundingClientRect().top;
      timelineRef.current.style.height = `${lastCardTop - timelineTop + 40}px`;
    }
  }, [isVisible]);

  return (
    <div
      id="experience"
      className="relative flex flex-col items-center py-2 md:px-8"
    >
      {/* Heading */}
      <h2 className="text-3xl font-bold mb-16 text-gray-100">Experience</h2>

      {/* Vertical Timeline */}
      <div
        ref={timelineRef}
        className="absolute left-1/2 transform -translate-x-1/2 w-[2px] bg-gradient-to-b from-indigo-500/0 via-indigo-500/30 to-indigo-500/0 overflow-hidden"
        style={{ top: "6rem" }}
      >
        <div className="absolute left-0 w-full h-32 bg-gradient-to-b from-transparent via-cyan-400 to-transparent opacity-75 animate-flow-down blur-[1px]"></div>
      </div>

      {experiences.map((exp, index) => (
        <div
          key={index}
          className={`experience-card relative flex flex-col items-center mb-12 md:mb-16 w-full max-w-xs sm:max-w-sm md:max-w-md lg:max-w-lg xl:max-w-2xl transition-all duration-700 ease-out ${
            isVisible[index]
              ? "opacity-100 translate-y-0 scale-100"
              : "opacity-0 translate-y-10 scale-90"
          }`}
          ref={index === experiences.length - 1 ? lastCardRef : null}
        >
          {/* Timeline Dot */}
          <div className="absolute -top-2 left-1/2 transform -translate-x-1/2 w-4 h-4 bg-indigo-400 rounded-full border-4 border-gray-900 shadow-[0_0_15px_rgba(99,102,241,0.8)] z-10"></div>

          {/* Experience Content */}
          <div className="pt-6 text-center w-full relative z-0 mt-4">
            {/* Year Badge */}
            <div className="inline-block mb-4 px-4 py-1 bg-indigo-500/10 border border-indigo-500/20 text-indigo-300 text-sm font-semibold rounded-full shadow-inner">
              {exp.year}
            </div>
            
            <h3 className="font-bold text-xl sm:text-2xl lg:text-3xl text-gray-100 mb-1">
              <a 
                href={exp.link} 
                target="_blank" 
                rel="noopener noreferrer" 
                className="hover:text-blue-400 transition-colors duration-300 relative group"
              >
                {exp.company}
                <span className="absolute -top-8 left-1/2 transform -translate-x-1/2 bg-white text-blue text-xs px-2 py-1 rounded opacity-0 group-hover:opacity-100 transition-opacity duration-300 whitespace-nowrap">
                  Visit {exp.link}
                </span>
              </a>
            </h3>
            <p className="text-xs sm:text-sm lg:text-base font-semibold text-gray-300">
              {exp.role}
            </p>
            <p className="text-xs sm:text-sm lg:text-base italic text-sky-400">
              {exp.duration}
            </p>
            <div className="text-xs sm:text-sm lg:text-base mt-4 text-gray-200 text-left space-y-2">
              {exp.description.split('\n').map((line, i) => (
                <p key={i}>{line}</p>
              ))}
            </div>
            {exp.tech && (
              <div className="flex flex-wrap gap-2 mt-4 justify-center">
                {exp.tech.map((techItem, techIndex) => (
                  <span key={techIndex} className="px-3 py-1 bg-gradient-to-r from-blue-600/20 to-purple-600/20 text-blue-200 text-xs font-semibold rounded-full border border-blue-500/30">
                    {techItem}
                  </span>
                ))}
              </div>
            )}
          </div>
        </div>
      ))}
    </div>
  );
};

export default Experience;
